import { AxiosResponse } from 'axios';
import { request } from '../../services/api/request';
import { AuthPayload, AuthUserState } from './auth.model';

export function signInRequest(payload: AuthPayload): Promise<AxiosResponse<AuthUserState>> {
  return request().post('/auth/login', payload);
}
